import React from "react";
import { Navigate } from "react-router-dom";
import { checkTokenAvailable } from "../Utils/verifyUser";
import MainLayout from "../_Containers/MainLayout";
function PrivateRoute({ component: Component, ...rest }) {
  return checkTokenAvailable() ? (
    <MainLayout component={Component} />
  ) : (
    <Navigate to="/login" replace={true} />
  );
}
export default PrivateRoute;
